import React from 'react';
import {EditOutlined} from '@ant-design/icons';
import {Card, Col, Row} from 'antd';

import '../../assets/less/Card.less';
import {Car} from '../../types/carTypes';
import {labelColSize, dataColSize} from '../../assets/styles';

interface CarSpecsCardProps {
    car: Partial<Car>;
    onEdit?: (state: boolean) => void;
    isStaff: boolean;
}

const CarSpecsCard = ({car, onEdit, isStaff = false}: CarSpecsCardProps) => {

    return (
        <Card
            title="Specs"
            bordered={true}
            className="details-card"
            extra={
                (isStaff && onEdit) &&
                <EditOutlined key="edit" onClick={() => onEdit(true)}/>
            }
        >
            <Row>
                <Col {...labelColSize}>
                    <strong>Make:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{car.make || 'N/A'}</span>
                </Col>
            </Row>
            <Row>
                <Col {...labelColSize}>
                    <strong>Model:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{car.model || 'N/A'}</span>
                </Col>
            </Row>
            <Row>
                <Col {...labelColSize}>
                    <strong>Year:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{car.year || 'N/A'}</span>
                </Col>
            </Row>
            <Row>
                <Col {...labelColSize}>
                    <strong>Colour:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{car.colour || 'N/A'}</span>
                </Col>
            </Row>
            <Row>
                <Col {...labelColSize}>
                    <strong>Seats:</strong>
                </Col>
                <Col {...dataColSize}>
                    <span className="long-text-wrap">{car.seats || 'N/A'}</span>
                </Col>
            </Row>
        </Card>
    );
}

export default CarSpecsCard;
